import { createAsyncThunk } from '@reduxjs/toolkit';
import { callMotivesValidationProducts } from '../../services/ValidationProductService';
import { contactBackBff } from '../../../src/config/paths';

export const validationProduct = createAsyncThunk(
  'oc/validate/change-product',
  async (data) => {
    const response = await callMotivesValidationProducts(data, contactBackBff);
    return response.data;
  },
);
